// Curated hospitality imagery.
// Real iFotoLife brand assets (client-provided) + design-guideline ambiance shots.
export const IMG = {
  // Design-guideline ambiance (Pexels)
  familyBeach: "https://images.pexels.com/photos/14349700/pexels-photo-14349700.jpeg",
  resortAerial: "https://images.pexels.com/photos/9400976/pexels-photo-9400976.jpeg",
  resortPool: "https://images.pexels.com/photos/20898616/pexels-photo-20898616.jpeg",
  photographer: "https://images.pexels.com/photos/13521541/pexels-photo-13521541.jpeg",
  hotelLobby: "https://images.pexels.com/photos/14841129/pexels-photo-14841129.jpeg",

  // Real brand assets (used in the user tutorial)
  brandPhotographer: "https://customer-assets-agu9un31.emergentagent.net/job_ifotolife-pitch/artifacts/012gtzpd_748c0ebe-2f14-43d0-8b6f-cba2dc359ee8.JPG",
  familyPool: "https://customer-assets-agu9un31.emergentagent.net/job_ifotolife-pitch/artifacts/sj2mmd5k_55d71b45-8aef-4fd4-8b90-366438508938.JPG",
  familyWatermelon: "https://customer-assets-agu9un31.emergentagent.net/job_ifotolife-pitch/artifacts/hz0q01xo_0388ca82-7335-464e-93ec-837507ce4012.JPG",
  familyPoolDad: "https://customer-assets-agu9un31.emergentagent.net/job_ifotolife-pitch/artifacts/wtvwmn7g_d47b4034-cd0a-4580-8c3a-297746296e2b.JPG",
  resortActivities: "https://customer-assets-agu9un31.emergentagent.net/job_ifotolife-pitch/artifacts/bd6uiziz_853e023f-af70-4b27-9871-2e7d315e9689.JPG",
};
